import React from 'react';
import { connect } from 'react-redux';
import documents from '../../assets/document/documents.png';
import prod from '../../assets/document/prod.png';
import "./noStudyMaterial.css";
import { useTranslation } from 'react-i18next';

function NoStudyMAterialmsg(props) {
  const { t } = useTranslation();
  return (<>
    <div className="up">
      <div className="up-container">
        {props.selectedtab == "StudyLibrary" ?
          <div>
            {props.course_type.length > 0 && props.course_type.filter((data) => data.isPaid !== "Y").length > 0 ? <p className="up-text1">{props.auth.is_institute_type_school == false ? t('studyMaterial.clickCourseNameToView') : t('studyMaterial.clickStandardToView')}</p> : <p className="up-text1">{t('studyMaterial.noStudyMaterialsShared')}</p>}

            <img src={documents} alt="" />
          </div> :
          <div className="image-div">
            {props.course_type.filter((data) => data.isPaid == "Y").length > 0 ? <p className="up-text1">{t('studyMaterial.clickProductNameToView')}</p> : <p className="up-text1">{t('studyMaterial.noMaterialAvailable')}</p>}
            <p className="up-text1"></p>
            <img src={prod} alt="" />
          </div>
        }
      </div>
    </div>
  </>);
}

const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(NoStudyMAterialmsg)